export default __webpack_public_path__ + "static/media/iconfinder_badge-css-3_317756.9d56f943.png";